import React from 'react';
import { defineMessages } from 'react-intl';
import Confirm from 'components/Confirm';
import Message from 'components/Message';

const messages = defineMessages({
  title: {
    id: 'yield-management.mark-class-as-full-confirmation-modal.title',
    defaultMessage: 'Are you sure?',
  },
  body: {
    id: 'yield-management.mark-class-as-full-confirmation-modal.body',
    defaultMessage:
      'This will stop all new reservations from ClassPass members. Are you sure you want to mark this session as full?',
  },
  cancel: {
    id: 'yield-management.mark-class-as-full-confirmation-modal.cancel',
    defaultMessage: 'Cancel',
  },
  markAsFull: {
    id: 'yield-management.mark-class-as-full-confirmation-modal.turn-off',
    defaultMessage: 'Mark as full',
  },
});

const MarkClassAsFullConfirmationModal = props => (
  <Confirm
    title={<Message message={messages.title} />}
    cancelNode={<Message message={messages.cancel} />}
    acceptNode={<Message message={messages.markAsFull} />}
    {...props}>
    <Message message={messages.body} />
  </Confirm>
);

export default MarkClassAsFullConfirmationModal;
